<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Danksagung</span></h1>
<p class="p_normal"> </p>
<p class="p_normal"> </p>
<p class="p_norm-noindent"><span class="calibre3">JEANNIE, MEINE</span> Freundin und Zeichensetzungs-Guru. Danke für deine Unterstützung und Hingabe. Durch dich ist es so viel leichter.</p>
<p class="p_normal">Ann, Jackie, Lyn und Sharon. Kritiker, die sich nie scheuen, mir zu sagen, wenn ich einen Fehler gemacht habe, und mir den Kopf tätscheln, wenn ich es nötig habe.</p>
<p class="p_normal">Marita, die außergewöhnliche Videomacherin. Dein Talent inspiriert mich. Danke, dass du es mit mir teilst.</p>
<p class="p_normal">Reese Dante. Dein Auge fürs Detail ist legendär. Vielen Dank für mein wunderschönes Buchcover.</p>
<p class="p_normal">Zu guter Letzt den wundervollen Leuten von Dreamspinner Press, die immer da sind, wenn man sie braucht. Danke!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?1c215994